import PRStatusBadge from "../components/PRStatusBadge";
import { formatDate } from "../../../../../../utils/formatUtils";

const prColumns = [
  {
    key: "pr_no",
    label: "PR No",
    render: (row, onView) => (
      <span
        className="pr-link"
        onClick={() => onView(row)}
      >
        {row.pr_no}
      </span>
    ),
  },

  //{ key: "pr_date", label: "Date" },
  {
    key: "pr_date",
    label: "Date",
    render: (row) => formatDate(row.pr_date),
  },
  //{ key: "department_name", label: "Department" },
  {
  key: "department_name",
  label: "Department",
  render: (row) => row.department_name || row.department_id || "-"
},

  {
    key: "status",
    label: "Status",
    render: (row) => (
      <PRStatusBadge status={row.status_name || row.status_code || row.status_id} />
    ),

  },

  {
  key: "actions",
  label: "Actions",
  render: (row, onView, onEdit) => (
    <>
      <span
        className="pr-action-link"
        onClick={() => onView(row)}
      >
        View
      </span>

      {row.status_code === "DRAFT" && (
        <>
          {" | "}
          <span
            className="pr-action-link"
            onClick={() => onEdit(row)}
          >
            Edit
          </span>
        </>
      )}
    </>
  ),
},
];

export default prColumns;
